import WebApp from '@twa-dev/sdk';

import { DESKTOP_PLATFORMS } from '@/shared/constants';

export const isDesktop = () => {
  const platform = WebApp.platform;

  return DESKTOP_PLATFORMS.some((item) => platform.toLowerCase().startsWith(item));
};
